/* eslint-disable max-len */
import {
  EDA_BASE_API_URL,
  EDA_GET_INTEGRATION_LOG_1H_AND_24H_ENDPOINT,
  EDA_GET_INTEGRATION_LOG_ACUTE_COMPLICATIONS_ENDPOINT,
  EDA_GET_INTEGRATION_LOG_ADMISSIONS_ENDPOINT,
  EDA_GET_INTEGRATION_LOG_COMORBIDITIES_ENDPOINT,
  EDA_GET_INTEGRATION_LOG_DIAGNOSIS_ENDPOINT,
  EDA_GET_INTEGRATION_LOG_INVASIVE_DEVICE_ENDPOINT,
  EDA_GET_INTEGRATION_LOG_LAB_MICRO_ENDPOINT,
  EDA_GET_INTEGRATION_LOG_SAPS3_ENDPOINT,
  EDA_GET_INTEGRATION_LOG_UNIT_RESOURCES_ENDPOINT,
  EDA_GET_INTEGRATION_TYPES_ENDPOINT,
  EDA_GET_INTEGRATION_STATUS_ENDPOINT,
} from '../constants/integrationsConstants';
import httpService from './httpService';

const integrationsService = () => {
  const getIntegrationLog1hAnd24h = async ({
    page, itensPerPage, orderAscending, order, hospitalId, visitId, startDate, finishDate, culture,
  }) => {
    const { get } = httpService();
    const params = {
      Page: page, // int
      ItensPerPage: itensPerPage, // int
      OrderAscending: orderAscending, // boolean
      Order: order, // int - somente 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26
      HospitalId: hospitalId, // string Guid
      VisitId: visitId, // string
      StartDate: startDate, // string datetime ISO
      FinishDate: finishDate, // string datetime ISO
      Culture: culture, // string - geralmente o back-end pega esse dado, não precisa enviar
    };

    const result = await get(EDA_BASE_API_URL + EDA_GET_INTEGRATION_LOG_1H_AND_24H_ENDPOINT, params);
    return result;
  };

  const getIntegrationLog1hAnd24hErrors = async ({
    logId, page, itensPerPage, orderAscending, order, integrationLog1hAnd24hId, errorTypeId, errorMessage, culture,
  }) => {
    const { get } = httpService();
    const params = {
      logId, // int
      Page: page, // int
      ItensPerPage: itensPerPage, // int
      OrderAscending: orderAscending, // boolean
      Order: order, // int - somente 1, 2, 3, 4, 5, 6, 7
      IntegrationLog1hAnd24hId: integrationLog1hAnd24hId, // int
      ErrorTypeId: errorTypeId, // int
      ErrorMessage: errorMessage, // string
      Culture: culture, // string - geralmente o back-end pega esse dado, não precisa enviar
    };

    const result = await get(`${EDA_BASE_API_URL + EDA_GET_INTEGRATION_LOG_1H_AND_24H_ENDPOINT}/${logId}/errors`, params);
    return result;
  };

  const getIntegrationLog1hAnd24hErrorsRefined = async ({
    page, itensPerPage, orderAscending, order, hospitalId, visitId, startDate, finishDate, culture,
  }) => {
    const { get } = httpService();
    const params = {
      Page: page, // int
      ItensPerPage: itensPerPage, // int
      OrderAscending: orderAscending, // boolean
      Order: order, // int - somente 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19
      HospitalId: hospitalId, // string Guid
      VisitId: visitId, // string
      StartDate: startDate, // string datetime ISO
      FinishDate: finishDate, // string datetime ISO
      Culture: culture, // string - geralmente o back-end pega esse dado, não precisa enviar
    };

    const result = await get(`${EDA_BASE_API_URL + EDA_GET_INTEGRATION_LOG_1H_AND_24H_ENDPOINT}/refined`, params);
    return result;
  };

  const getIntegrationLog1hAnd24hErrorsRefinedExamError = async ({
    examId, page, itensPerPage, orderAscending, order, firstHourExamEpimedId, integrationTypeId, errorTypeId, errorMessage, culture,
  }) => {
    const { get } = httpService();
    const params = {
      examId, // int
      Page: page, // int
      ItensPerPage: itensPerPage, // int
      OrderAscending: orderAscending, // boolean
      Order: order, // int - somente 1, 2, 3, 4, 5, 6, 7
      FirstHourExamEpimedId: firstHourExamEpimedId, // int
      IntegrationTypeId: integrationTypeId, // int nullable
      ErrorTypeId: errorTypeId, // int
      ErrorMessage: errorMessage, // string
      Culture: culture, // string - geralmente o back-end pega esse dado, não precisa enviar
    };

    const result = await get(`${EDA_BASE_API_URL + EDA_GET_INTEGRATION_LOG_1H_AND_24H_ENDPOINT}/refined/${examId}/errors`, params);
    return result;
  };

  const getIntegrationLogAcuteComplications = async ({
    page, itensPerPage, orderAscending, order, hospitalId, visitId, startDate, finishDate, culture, integrationStatus, firstHourComplication, twentyFourHourComplication,
  }) => {
    const { get } = httpService();
    const params = {
      Page: page, // int
      ItensPerPage: itensPerPage, // int
      OrderAscending: orderAscending, // boolean
      Order: order, // int - somente 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30
      HospitalId: hospitalId, // string Guid
      VisitId: visitId, // string
      StartDate: startDate, // string datetime ISO
      FinishDate: finishDate, // string datetime ISO
      Culture: culture, // string - geralmente o back-end pega esse dado, não precisa enviar,
      IntegrationStatus: integrationStatus, // filtra por status - int
      FirstHour: firstHourComplication, // filtra por complicações de 1 hora - string = 'true' ou 'false'
      TwentyFourHours: twentyFourHourComplication, // filtra por complicações de 24 horas - string = 'true' ou 'false'
    };

    const result = await get(EDA_BASE_API_URL + EDA_GET_INTEGRATION_LOG_ACUTE_COMPLICATIONS_ENDPOINT, params);
    return result;
  };

  const getIntegrationLogAcuteComplicationsErrors = async ({
    logId, page, itensPerPage, orderAscending, order, integrationLogAcuteComplicationId, errorTypeId, startDate, finishDate, errorMessage, culture,
  }) => {
    const { get } = httpService();
    const params = {
      logId, // int
      Page: page, // int
      ItensPerPage: itensPerPage, // int
      OrderAscending: orderAscending, // boolean
      Order: order, // int - somente 1, 2, 3, 4, 5, 6, 7, 8, 9, 10
      IntegrationLogAcuteComplicationId: integrationLogAcuteComplicationId, // int
      ErrorTypeId: errorTypeId,
      StartDate: startDate, // string datetime ISO
      FinishDate: finishDate, // string datetime ISO
      ErrorMessage: errorMessage, // string
      Culture: culture, // string - geralmente o back-end pega esse dado, não precisa enviar
    };

    const result = await get(`${EDA_BASE_API_URL + EDA_GET_INTEGRATION_LOG_ACUTE_COMPLICATIONS_ENDPOINT}/${logId}/errors`, params);
    return result;
  };

  const getIntegrationLogAdmissions = async ({
    page, itensPerPage, orderAscending, order, hospitalId, startDate, finishDate, visitId, patientId, errorTypeId, statusId, culture, integrationStatus,
  }) => {
    const { get } = httpService();
    const params = {
      Page: page, // int
      ItensPerPage: itensPerPage, // int
      OrderAscending: orderAscending, // boolean
      Order: order, // int - somente 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69
      HospitalId: hospitalId, // string
      StartDate: startDate, // string
      FinishDate: finishDate, // string
      VisitId: visitId, // string
      PatientId: patientId, // string
      ErrorTypeId: errorTypeId, // string
      StatusId: statusId, // string
      Culture: culture, // string - geralmente o back-end pega esse dado, não precisa enviar
      IntegrationStatus: integrationStatus, // filtra por status - int
    };
    const result = await get(EDA_BASE_API_URL + EDA_GET_INTEGRATION_LOG_ADMISSIONS_ENDPOINT, params);
    return result;
  };

  const getIntegrationLogComorbidities = async ({
    page, itensPerPage, orderAscending, order, hospitalId, visitId, startDate, finishDate, culture, integrationStatus,
  }) => {
    const { get } = httpService();
    const params = {
      Page: page, // int
      ItensPerPage: itensPerPage, // int
      OrderAscending: orderAscending, // boolean
      Order: order, // int - somente 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30
      HospitalId: hospitalId, // string Guid
      VisitId: visitId, // string
      StartDate: startDate, // string datetime ISO
      FinishDate: finishDate, // string datetime ISO
      Culture: culture, // string - geralmente o back-end pega esse dado, não precisa enviar
      IntegrationStatus: integrationStatus, // filtra por status - int
    };

    const result = await get(EDA_BASE_API_URL + EDA_GET_INTEGRATION_LOG_COMORBIDITIES_ENDPOINT, params);
    return result;
  };

  const getIntegrationLogComorbiditiesErrors = async ({
    logId, page, itensPerPage, orderAscending, order, integrationLogComorbidityId, errorTypeId, // startDate, finishDate,
    errorMessage, culture,
  }) => {
    const { get } = httpService();
    const params = {
      logId, // int
      Page: page, // int
      ItensPerPage: itensPerPage, // int
      OrderAscending: orderAscending, // boolean
      Order: order, // int - somente 1, 2, 3, 4, 5, 6, 7, 8
      IntegrationLogComorbidityId: integrationLogComorbidityId, // int
      ErrorTypeId: errorTypeId,
      // StartDate: startDate, // string datetime ISO
      // FinishDate: finishDate, // string datetime ISO
      ErrorMessage: errorMessage, // string
      Culture: culture, // string - geralmente o back-end pega esse dado, não precisa enviar
    };

    const result = await get(`${EDA_BASE_API_URL + EDA_GET_INTEGRATION_LOG_COMORBIDITIES_ENDPOINT}/${logId}/errors`, params);
    return result;
  };

  const getIntegrationLogDiagnosis = async ({
    page, itensPerPage, orderAscending, order, hospitalId, visitId, startDate, finishDate, culture,
    integrationStatus,
  }) => {
    const { get } = httpService();
    const params = {
      Page: page, // int
      ItensPerPage: itensPerPage, // int
      OrderAscending: orderAscending, // boolean
      Order: order, // int - somente 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34
      HospitalId: hospitalId, // string Guid
      VisitId: visitId, // string
      StartDate: startDate, // string datetime ISO
      FinishDate: finishDate, // string datetime ISO
      Culture: culture, // string - geralmente o back-end pega esse dado, não precisa enviar
      IntegrationStatus: integrationStatus, // filtra por status - int
    };

    const result = await get(EDA_BASE_API_URL + EDA_GET_INTEGRATION_LOG_DIAGNOSIS_ENDPOINT, params);
    return result;
  };

  const getIntegrationLogDiagnosisErrors = async ({
    logId, page, itensPerPage, orderAscending, order, integrationLogDiagnosisId, errorTypeId, // startDate, finishDate,
    errorMessage, culture,
  }) => {
    const { get } = httpService();
    const params = {
      logId, // int
      Page: page, // int
      ItensPerPage: itensPerPage, // int
      OrderAscending: orderAscending, // boolean
      Order: order, // int - somente 1, 2, 3, 4, 5, 6, 7, 8
      IntegrationLogDiagnosisId: integrationLogDiagnosisId, // int
      ErrorTypeId: errorTypeId,
      // StartDate: startDate, // string datetime ISO
      // FinishDate: finishDate, // string datetime ISO
      ErrorMessage: errorMessage, // string
      Culture: culture, // string - geralmente o back-end pega esse dado, não precisa enviar
    };

    const result = await get(`${EDA_BASE_API_URL + EDA_GET_INTEGRATION_LOG_DIAGNOSIS_ENDPOINT}/${logId}/errors`, params);
    return result;
  };

  const getIntegrationLogInvasiveDevice = async ({
    page, itensPerPage, orderAscending, order, hospitalId, visitId, startDate, finishDate, culture, integrationStatus,
  }) => {
    const { get } = httpService();
    const params = {
      Page: page, // int
      ItensPerPage: itensPerPage, // int
      OrderAscending: orderAscending, // boolean
      Order: order, // int - somente 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41
      HospitalId: hospitalId, // string Guid
      VisitId: visitId, // string
      StartDate: startDate, // string datetime ISO
      FinishDate: finishDate, // string datetime ISO
      Culture: culture, // string - geralmente o back-end pega esse dado, não precisa enviar
      IntegrationStatus: integrationStatus, // filtra por status - int
    };

    const result = await get(EDA_BASE_API_URL + EDA_GET_INTEGRATION_LOG_INVASIVE_DEVICE_ENDPOINT, params);
    return result;
  };

  const getIntegrationLogInvasiveDeviceErrors = async ({
    logId, page, itensPerPage, orderAscending, order, integrationLogInvasiveDeviceId, errorTypeId, startDate, finishDate,
    errorMessage, culture,
  }) => {
    const { get } = httpService();
    const params = {
      logId, // int
      Page: page, // int
      ItensPerPage: itensPerPage, // int
      OrderAscending: orderAscending, // boolean
      Order: order, // int - somente 1, 2, 3, 4, 5, 6, 7, 8, 9, 10
      IntegrationLogInvasiveDeviceId: integrationLogInvasiveDeviceId, // int
      ErrorTypeId: errorTypeId,
      StartDate: startDate, // string datetime ISO
      FinishDate: finishDate, // string datetime ISO
      ErrorMessage: errorMessage, // string
      Culture: culture, // string - geralmente o back-end pega esse dado, não precisa enviar
    };

    const result = await get(`${EDA_BASE_API_URL + EDA_GET_INTEGRATION_LOG_INVASIVE_DEVICE_ENDPOINT}/${logId}/errors`, params);
    return result;
  };

  const getIntegrationLogInvasiveDeviceErrorsRefined = async ({
    logId, page, itensPerPage, orderAscending, order, integrationLogInvasiveDeviceId, errorTypeId, startDate, finishDate,
    errorMessage, culture,
  }) => {
    const { get } = httpService();
    const params = {
      logId, // int
      Page: page, // int
      ItensPerPage: itensPerPage, // int
      OrderAscending: orderAscending, // boolean
      Order: order, // int - somente 1, 2, 3, 4, 5, 6, 7, 8, 9
      IntegrationLogInvasiveDeviceId: integrationLogInvasiveDeviceId, // int
      ErrorTypeId: errorTypeId,
      StartDate: startDate, // string datetime ISO
      FinishDate: finishDate, // string datetime ISO
      ErrorMessage: errorMessage, // string
      Culture: culture, // string - geralmente o back-end pega esse dado, não precisa enviar
    };

    const result = await get(`${EDA_BASE_API_URL + EDA_GET_INTEGRATION_LOG_INVASIVE_DEVICE_ENDPOINT}/${logId}/errors/refined`, params);
    return result;
  };

  const getIntegrationLogLabMicro = async ({
    page, itensPerPage, orderAscending, order, hospitalId, startDate, finishDate,
  }) => {
    const { get } = httpService();
    const params = {
      Page: page, // int
      ItensPerPage: itensPerPage, // int
      OrderAscending: orderAscending, // boolean
      Order: order, // int - somente 1, 2, 3, 4, 5, 6, 7, 8, 9
      HospitalId: hospitalId, // string Guid
      StartDate: startDate, // string datetime ISO
      FinishDate: finishDate, // string datetime ISO
    };

    const result = await get(EDA_BASE_API_URL + EDA_GET_INTEGRATION_LOG_LAB_MICRO_ENDPOINT, params);
    return result;
  };

  const getIntegrationLogSAPS3 = async ({
    page, itensPerPage, orderAscending, order, hospitalId, visitId, startDate, finishDate, culture, integrationStatus,
  }) => {
    const { get } = httpService();
    const params = {
      Page: page, // int
      ItensPerPage: itensPerPage, // int
      OrderAscending: orderAscending, // boolean
      Order: order, // int - somente 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29
      HospitalId: hospitalId, // string Guid
      VisitId: visitId, // string
      StartDate: startDate, // string datetime ISO
      FinishDate: finishDate, // string datetime ISO
      Culture: culture, // string - geralmente o back-end pega esse dado, não precisa enviar,
      IntegrationStatus: integrationStatus, // filtra por status - int
    };

    const result = await get(EDA_BASE_API_URL + EDA_GET_INTEGRATION_LOG_SAPS3_ENDPOINT, params);
    return result;
  };

  const getIntegrationLogSAPS3Errors = async ({
    logId, page, itensPerPage, orderAscending, order, integrationLogSAPS3Id, errorTypeId, startDate, finishDate,
    errorMessage, culture,
  }) => {
    const { get } = httpService();
    const params = {
      logId, // int
      Page: page, // int
      ItensPerPage: itensPerPage, // int
      OrderAscending: orderAscending, // boolean
      Order: order, // int - somente 1, 2, 3, 4, 5, 6, 7, 8, 9, 10
      IntegrationLogSAPS3Id: integrationLogSAPS3Id, // int
      ErrorTypeId: errorTypeId,
      StartDate: startDate, // string datetime ISO
      FinishDate: finishDate, // string datetime ISO
      ErrorMessage: errorMessage, // string
      Culture: culture, // string - geralmente o back-end pega esse dado, não precisa enviar
    };

    const result = await get(`${EDA_BASE_API_URL + EDA_GET_INTEGRATION_LOG_SAPS3_ENDPOINT}/${logId}/errors`, params);
    return result;
  };

  const getIntegrationLogUnitResources = async ({
    page, itensPerPage, orderAscending, order, hospitalId, startDate, finishDate, visitId, culture, integrationStatus,
  }) => {
    const { get } = httpService();
    const params = {
      Page: page, // int
      ItensPerPage: itensPerPage, // int
      OrderAscending: orderAscending, // boolean
      Order: order, // int - somente 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29
      HospitalId: hospitalId, // string
      VisitId: visitId, // string
      StartDate: startDate, // string datetime ISO
      FinishDate: finishDate, // string datetime ISO
      Culture: culture, // string - geralmente o back-end pega esse dado, não precisa enviar
      IntegrationStatus: integrationStatus, // filtra por status - int
    };

    const result = await get(EDA_BASE_API_URL + EDA_GET_INTEGRATION_LOG_UNIT_RESOURCES_ENDPOINT, params);
    return result;
  };

  const getIntegrationLogUnitResourcesErrors = async ({
    logId, page, itensPerPage, orderAscending, order, integrationLogUnitResourceId, errorTypeId, startDate, finishDate,
    errorMessage, culture,
  }) => {
    const { get } = httpService();
    const params = {
      logId, // int
      Page: page, // int
      ItensPerPage: itensPerPage, // int
      OrderAscending: orderAscending, // boolean
      Order: order, // int - somente 1, 2, 3, 4, 5, 6, 7, 8, 9, 10
      IntegrationLogUnitResourceId: integrationLogUnitResourceId, // int
      ErrorTypeId: errorTypeId,
      StartDate: startDate, // string datetime ISO
      FinishDate: finishDate, // string datetime ISO
      ErrorMessage: errorMessage, // string
      Culture: culture, // string - geralmente o back-end pega esse dado, não precisa enviar
    };

    const result = await get(`${EDA_BASE_API_URL + EDA_GET_INTEGRATION_LOG_UNIT_RESOURCES_ENDPOINT}/${logId}/errors`, params);
    return result;
  };

  const getIntegrationTypes = async () => {
    const { get } = httpService();
    const params = null;

    const result = await get(EDA_BASE_API_URL + EDA_GET_INTEGRATION_TYPES_ENDPOINT, params);
    return result;
  };

  const getIntegrationStatus = async ({ typeIdIntegration, culture }) => {
    const { get } = httpService();
    const params = {
      integrationTypeId: typeIdIntegration,
      cultureCode: culture,
    };

    const result = await get(EDA_BASE_API_URL + EDA_GET_INTEGRATION_STATUS_ENDPOINT, params);
    return result;
  };

  return {
    getIntegrationLog1hAnd24h,
    getIntegrationLog1hAnd24hErrors,
    getIntegrationLog1hAnd24hErrorsRefined,
    getIntegrationLog1hAnd24hErrorsRefinedExamError,
    getIntegrationLogAcuteComplications,
    getIntegrationLogAcuteComplicationsErrors,
    getIntegrationLogAdmissions,
    getIntegrationLogComorbidities,
    getIntegrationLogComorbiditiesErrors,
    getIntegrationLogDiagnosis,
    getIntegrationLogDiagnosisErrors,
    getIntegrationLogInvasiveDevice,
    getIntegrationLogInvasiveDeviceErrors,
    getIntegrationLogInvasiveDeviceErrorsRefined,
    getIntegrationLogLabMicro,
    getIntegrationLogSAPS3,
    getIntegrationLogSAPS3Errors,
    getIntegrationLogUnitResources,
    getIntegrationLogUnitResourcesErrors,
    getIntegrationTypes,
    getIntegrationStatus,
  };
};

export default integrationsService;
